import * as React from 'react';
import './ChangePassword.scss';
import AccountInfo from '../AccountInfo';
import Button from 'src/components/common/Button';
import Input from 'src/components/common/Input';
import { INewPasswordValidation } from 'src/model/modules/accountview.model';
import { goToForgot, goToRedirect } from 'src/utils/navigation';
import Loader from 'src/components/common/Loader';
import Alert from 'src/pages/ForgotPasswordView/components/Alert';

interface IChangePasswordProps {
  isLoading: boolean;
  hasError: boolean;
  currentPassword: string;
  newPassword: string;
  newPasswordRepeat: string;
  passwordValidation: INewPasswordValidation;
  onCurrentPasswordChange(value: string): void;
  onNewPasswordChange(value: string): void;
  onNewPasswordRepeatChange(value: string): void;
  onChangePassword(cb?: (result: boolean) => void): void;
  onClearError(): void;
}

export function ChangePassword(props: IChangePasswordProps) {
  const handleOnPasswordChanged = (result: boolean) => {
    goToRedirect();
  };

  const invalid =
    props.passwordValidation.dirty && !props.passwordValidation.valid;
  return (
    <div className="rp-change-password">
      {props.isLoading ? <Loader /> : null}
      <AccountInfo />

      {props.hasError ? (
        <Alert type="error" icon="rpds-error" onClose={props.onClearError}>
          We couldn't change your password, please make sure you entered your
          current password correctly.
        </Alert>
      ) : null}
      <div className="rp-change-password--content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-8">
              <h1>Change your Password</h1>
              <p className="rp-change-password--subtitle">
                Use the form below to change your Reliable Parts account
                password.
              </p>
            </div>
            <div className="col-12 col-md-4">
              <Button
                label="Forgot Password"
                textTransform="capitalize"
                buttonClass="secondary-button rp-change-password--resetbtn"
                height="48px"
                icon={{
                  position: 'left',
                  icon: 'rpds rpds-repeat'
                }}
                action={goToForgot}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4">
              <Input
                label="Current Password"
                value={props.currentPassword}
                type="password"
                onChange={props.onCurrentPasswordChange}
              />

              <Input
                label="New Password"
                value={props.newPassword}
                type="password"
                onChange={props.onNewPasswordChange}
                invalid={invalid}
                invalidMessage={props.passwordValidation.message}
              />

              <Input
                label="Re-enter New Password"
                value={props.newPasswordRepeat}
                type="password"
                onChange={props.onNewPasswordRepeatChange}
                invalid={invalid}
                invalidMessage={props.passwordValidation.message}
              />

              <Button
                label="Change Password"
                textTransform="uppercase"
                buttonClass="primary-button"
                height="48px"
                action={() => props.onChangePassword(handleOnPasswordChanged)}
                disabled={!props.passwordValidation.valid}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
